import { render, staticRenderFns } from "./BuscarArticulos.vue?vue&type=template&id=de381884&scoped=true"
import script from "./BuscarArticulos.vue?vue&type=script&lang=js"
export * from "./BuscarArticulos.vue?vue&type=script&lang=js"
import style0 from "./BuscarArticulos.vue?vue&type=style&index=0&id=de381884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de381884",
  null
  
)

export default component.exports